import { inject } from '@angular/core';
import { CanMatchFn, Route } from '@angular/router';
import { FeatureFlagService } from '@core/services/feature-flag/feature-flag.service';
import { FeatureFlagsEnum } from '@generated/featureFlags.enum';

export const featureFlagGuard: CanMatchFn = async (route: Route) => {
  const featureFlagSvc = inject(FeatureFlagService);

  const flags = (route.data?.['flags'] as FeatureFlagsEnum[] | undefined) ?? [];

  // `canMatch` roda de forma síncrona já no boot, mas os flags são carregados
  // via GraphQL de forma assíncrona. Se lermos o mapa antes do fetch resolver
  // (deep-link/reload para uma rota com flag), o `every` retorna false, a rota
  // não casa e a navegação cai no wildcard `**` -> redirect para a raiz. Por
  // isso aguardamos o carregamento (isFeatureFlagEnabled faz o fetch sob demanda
  // quando ainda não buscou) antes de decidir.
  const results = await Promise.all(flags.map((flag) => featureFlagSvc.isFeatureFlagEnabled(flag)));

  return results.every(Boolean);
};
